module.exports = __webpack_public_path__ + "static/media/ClarenceMurphyDrone.73a658c3.jpg";